import { render, staticRenderFns } from "./_org_image.vue?vue&type=template&id=0dba7058&"
import script from "./_org_image.vue?vue&type=script&lang=js&"
export * from "./_org_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports